<template>
  <div class="space-y-3">
    <div
      v-if="!mcpServers?.length"
      class="text-center py-8 text-muted-foreground"
    >
      <Server class="h-12 w-12 mx-auto mb-4 opacity-50" />
      <p>{{ t("common.noResults") }}</p>
    </div>

    <div v-else class="space-y-3">
      <div
        v-for="mcpServer in mcpServers"
        :key="mcpServer.id"
        class="flex items-center justify-between p-4 border rounded-lg"
      >
        <div class="flex items-center space-x-3">
          <div class="relative">
            <div
              class="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center"
            >
              <Server class="h-5 w-5 text-primary" />
            </div>
            <div
              v-if="mcpServer.isTrusted"
              v-tooltip="t('settings.mcpServers.trustedTooltip')"
              class="absolute -bottom-1 -right-1 h-5 w-5 rounded-full bg-green-500 flex items-center justify-center border-2 border-background"
            >
              <ShieldCheck class="h-3 w-3 text-white" />
            </div>
          </div>

          <div>
            <div class="font-medium">
              {{ mcpServer.name }}
            </div>
            <div class="text-sm text-muted-foreground flex items-center gap-1">
              <div 
                :class="[
                  'h-2 w-2 rounded-full',
                  mcpServer.isActive ? 'bg-green-500' : 'bg-gray-400'
                ]"
              />
              {{ mcpServer.isActive ? t("common.enabled") : t("common.disabled") }}
            </div>
          </div>
        </div>

        <McpServersListActions
          :mcp-server="mcpServer"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Server, ShieldCheck } from "lucide-vue-next";
import type { ApiMcpServer } from "~/server/api/organizations/[organizationId]/mcpServers/types";

const { t } = useI18n();

defineProps<{
  mcpServers: ApiMcpServer[];
}>();
</script>
